import { render, staticRenderFns } from "./messageEdit.vue?vue&type=template&id=62706b55"
import script from "./messageEdit.vue?vue&type=script&lang=js"
export * from "./messageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports